import { OnInit, Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/services/admin.service';
import { ArrangerDetails } from 'src/app/intefaces/arranger-details.interface';

@Component({
    selector: 'app-arranger-contract-date-form',
    templateUrl: './arranger-contract-date-form.component.html',
    styleUrls: ['./arranger-contract-date-form.component.scss']
})
export class ArrangerContractDateFormComponent implements OnInit {

    @Input() userId: number;

    isDataReady: boolean = false;
    form: FormGroup;
    isEditing: boolean = false;
    previousValue: any;
    arrangerDetails: ArrangerDetails;

    constructor(
        private formBuilder: FormBuilder,
        private alertService: HttpAlertService,
        private translate: TranslateService,
        private adminService: AdminService) {

        this.form = this.formBuilder.group({
            user_id: [0, Validators.required],
            contract_date_signment: [0, [Validators.required, Validators.max(100), Validators.min(0)]],
        });
    }

    ngOnInit(): void {
        this.adminService.getArrangerContractSignDate(this.userId).subscribe((response: any) => {
            this.form.patchValue(response.data.arranger_details);
            setTimeout(() => {
                this.form.disable();
            }, 100);
            this.isDataReady = true;
        });
    }

    public onEdit(): void {
        this.previousValue = this.form.value;
        this.isEditing = true;
        this.form.enable();
    }

    public cancelForm(): void {
        this.form.setValue(this.previousValue);
        this.isEditing = false;
        this.form.disable();
    }

    public onSubmitArrangerContractDateForm(): void {
        this.form.disable();
        this.adminService.updateArrangerContractSignDate(this.form.controls['user_id'].value, this.form.controls['contract_date_signment'].value ).subscribe((response: any) => {
            this.translate.get('data_updated_success').subscribe(t => {
                this.alertService.success(t);
            });
        }, error => {
            this.translate.get('data_updated_error').subscribe(t => {
                this.alertService.error(t);
            });
        });
        this.isEditing = false;
    }


}